// extracted by mini-css-extract-plugin
export default {"price":"DesignPrice_price__ke2cE","crossed":"DesignPrice_crossed__0OpZP","red":"DesignPrice_red__RSlvd"};